export const CONTENT_TYPE = {
  APPLICATION_JSON: 'application/json'
};
